export default __webpack_public_path__ + "static/media/logo.aabbb9ae.svg";